export default __webpack_public_path__ + "static/media/icon_help.a4b8f01e.svg";